import { Col, Divider, Row } from "antd";
import { PaymentDetailsProps } from "./PaymentDetails";
import { getFormattedCurrency } from "../../../../../lib/currencyFormatter";

export const BalanceDetails = ({ paymentRecord }: PaymentDetailsProps) => {
  return (
    <>
      <Row className="w-100 mb-2">
        <p className="h h5">Balances</p>
      </Row>
      <Row className="balance-container">
        <Row className="w-100 mb-3">
          <p className="h h6">Principal</p>
        </Row>
        <Row className="balance-content">
          <Col span={24}>
            <Row className="balance-item">
              <p className="text-md title info-label">Principal Paid</p>
              <p className="text-md w-500 text-no-wrap">
                {getFormattedCurrency(paymentRecord.principalPaid)}
              </p>
            </Row>
            <Row className="balance-item">
              <p className="text-md title info-label">Principal Adjustment</p>
              <p className="text-md w-500 text-no-wrap">
                {getFormattedCurrency(paymentRecord.principalAdjustment)}
              </p>
            </Row>
            <Divider className="balance-content-divider"></Divider>
            <Row className="balance-item">
              <p className="text-md title info-label">Principal Balance</p>
              <p className="text-md w-500 text-no-wrap">
                {getFormattedCurrency(paymentRecord.principalBalance)}
              </p>
            </Row>
          </Col>
        </Row>
      </Row>
      <Row className="balance-container">
        <Row className="w-100 mb-3">
          <p className="h h6">Interest</p>
        </Row>
        <Row className="balance-content">
          <Col span={24}>
            <Row className="balance-item">
              <p className="text-md title info-label">Interest Paid</p>
              <p className="text-md w-500 text-no-wrap">
                {getFormattedCurrency(paymentRecord.interestPaid)}
              </p>
            </Row>
            <Row className="balance-item">
              <p className="text-md title info-label">Interest Calculated</p>
              <p className="text-md w-500 text-no-wrap">
                {getFormattedCurrency(paymentRecord.interestCalculated)}
              </p>
            </Row>
            <Divider className="balance-content-divider"></Divider>
            <Row className="balance-item">
              <p className="text-md title info-label">
                Unpaid Interest Balance
              </p>
              <p className="text-md w-500 text-no-wrap">
                {getFormattedCurrency(paymentRecord.unpaidInterest)}
              </p>
            </Row>
          </Col>
        </Row>
      </Row>
      <Row className="balance-container">
        <Row className="w-100 mb-3">
          <p className="h h6">Late Charges</p>
        </Row>
        <Row className="balance-content">
          <Col span={24}>
            <Row className="balance-item">
              <p className="text-md title info-label">Late Charges Paid</p>
              <p className="text-md w-500 text-no-wrap">
                {getFormattedCurrency(paymentRecord.lateChargesPaid)}
              </p>
            </Row>
            <Row className="balance-item">
              <p className="text-md title info-label">
                Late Charges To Principal
              </p>
              <p className="text-md w-500 text-no-wrap">
                {getFormattedCurrency(paymentRecord.lateChargeToPrinciple)}
              </p>
            </Row>
            <Row className="balance-item">
              <p className="text-md title info-label">
                Late Charges Calculated
              </p>
              <p className="text-md w-500 text-no-wrap">
                {getFormattedCurrency(paymentRecord.lateChargesCalculated)}
              </p>
            </Row>
            <Divider className="balance-content-divider"></Divider>
            <Row className="balance-item">
              <p className="text-md title info-label">
                Unpaid Late Change Balance
              </p>
              <p className="text-md w-500 text-no-wrap">
                {getFormattedCurrency(paymentRecord.unpaidLateChargeBalance)}
              </p>
            </Row>
          </Col>
        </Row>
      </Row>
      <Row className="balance-container">
        <Row className="w-100 mb-3">
          <p className="h h6">Impound</p>
        </Row>
        <Row className="balance-content">
          <Col span={24}>
            <Row className="balance-item">
              <p className="text-md title info-label">To Impound</p>
              <p className="text-md w-500 text-no-wrap">
                {getFormattedCurrency(paymentRecord.toImpound)}
              </p>
            </Row>
            <Row className="balance-item">
              <p className="text-md title info-label">From Impound</p>
              <p className="text-md w-500 text-no-wrap">
                {getFormattedCurrency(paymentRecord.fromImpound)}
              </p>
            </Row>
            <Divider className="balance-content-divider"></Divider>
            <Row className="balance-item">
              <p className="text-md title info-label">Impound Balance</p>
              <p className="text-md w-500 text-no-wrap">
                {getFormattedCurrency(paymentRecord.impoundBalance)}
              </p>
            </Row>
          </Col>
        </Row>
      </Row>
    </>
  );
};
